import { useEffect, useState } from 'react';
import Mobile from './MobileBar';
import Desktop from './DesktopBar';
import { useSelector } from 'react-redux';
import { Capacitor } from '@capacitor/core';

const Navbar = () => {

    const platform = Capacitor.getPlatform()
    const isIOS = platform === 'ios'

    // Check isLogged
    const { isLogged, user, level } = useSelector(state => state.user);

    // Check window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const handleResize = () => {
        setWindowWidth(window.innerWidth)
    }
    useEffect(() => {
        window.addEventListener("resize", handleResize);
        // Clean up the listener in component amount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [])

    return (
        <div className={`
            w-full flex justify-center
            ${isIOS ? 'mt-4' : ''}
            `}>
            {windowWidth <= 768 && <Mobile isLogged={isLogged} level={level} />}
            {windowWidth > 768 && <Desktop isLogged={isLogged} user={user} level={level} />}
        </div>
    )
}

export default Navbar;